export enum SidebarVisibility {
  None = 0,
  Unset = 1, // Not used yet
  Open = 2,
  Close = 3,
}
